export type FirebaseRedirectMethod = 'google' | 'facebook' | 'twitter' | 'apple'

export const FIREBASE_REDIRECT_QUERY_KEY = '__firebase_redirect'

const URL_BASE = 'https://tipsy.invalid'

const isFirebaseRedirectMethod = (
  value: string | null
): value is FirebaseRedirectMethod =>
  value === 'google' ||
  value === 'facebook' ||
  value === 'twitter' ||
  value === 'apple'

const parseUrl = (input: string | URL) =>
  new URL(typeof input === 'string' ? input : input.href, URL_BASE)

const toRelativeUrl = (url: URL) => `${url.pathname}${url.search}${url.hash}`

export const getRedirectSignInMethod = (
  input: string | URL
): FirebaseRedirectMethod | undefined => {
  const method = parseUrl(input).searchParams.get(FIREBASE_REDIRECT_QUERY_KEY)
  return isFirebaseRedirectMethod(method) ? method : undefined
}

export const addRedirectSignInMethod = (
  input: string | URL,
  method: FirebaseRedirectMethod
) => {
  const url = parseUrl(input)
  url.searchParams.set(FIREBASE_REDIRECT_QUERY_KEY, method)
  return toRelativeUrl(url)
}

export const removeRedirectSignInMethod = (input: string | URL) => {
  const url = parseUrl(input)
  url.searchParams.delete(FIREBASE_REDIRECT_QUERY_KEY)
  return toRelativeUrl(url)
}

const replaceCurrentUrl = (url: string) => {
  window.history.replaceState(window.history.state, '', url)
}

export const markRedirectSignIn = (method: FirebaseRedirectMethod) => {
  const originalUrl = toRelativeUrl(parseUrl(window.location.href))
  replaceCurrentUrl(addRedirectSignInMethod(window.location.href, method))
  return originalUrl
}

export const clearRedirectSignIn = () => {
  replaceCurrentUrl(removeRedirectSignInMethod(window.location.href))
}

export const restoreRedirectSignInUrl = (url: string) => {
  replaceCurrentUrl(url)
}
